<!-- 活动页 web/act-index -->

<template>
  <div v-wechat-title="title">
    <div v-if="headerImg" class="textmobile-banner" style="display: block;">
      <van-image :src="headerImg" />
    </div>

    <div class="textmobile-content">
      <div id="test-editormd-view" class="markdown-body editormd-html-preview">
        <p>
          <a v-for="menu in menus" :key="menu.targetUrl" @click="go_targetUrl(menu)">
            <van-image :src="menu.imgUrl" alt="未配置图标"/>
          </a>
        </p>
      </div>
    </div>

    <!-- 活动菜单配置为弹窗形式展示 -->
    <div v-if="popupMenu" class="act-popup-menu">
      <van-image class="act-popup-menu-img" :src="popupMenu.imgUrl" />

      <van-icon class="act-popup-menu-close" name="close" @click="closePopupMenu" />
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant"
import { api_get_act_page_by_id } from "@/api/goods-api"
import preventBack from "@/mixins/prevent-back"
import { get_my_allow_use_cards_count } from "@/api/user"
import { $wx_kefu_rc, $kefu_img_url } from "@/util/wxSdk"

export default {
  name: "act-index",

  mixins: [preventBack],

  data() {
    return {
      menus: [],
      headerImg: '',
      title: '',
      checkBindCard: false,
      actId: 0,
      useCardsCount: 0,

      popupMenu: null
    }
  },

  mounted() {
    this.mounted_loadData()
  },

  methods: {
    $wx_kefu_rc: $wx_kefu_rc,

    $kefu_img_url: $kefu_img_url,

    closePopupMenu() {
      if (this.popupMenu?.header == 3 && this.popupMenu?.targetUrl) {
        var targetUrl = this.popupMenu?.targetUrl

        this.popupMenu = null // 弹窗没了

        location.href = targetUrl
        return
      }

      this.popupMenu = null
    },

    go_targetUrl(menu) {
      budo_log.info("#79 go_targetUrl", this.useCardsCount, JSON.stringify(menu))

      if (!menu.targetUrl) {
        Toast("未配跳转地址")
        return
      }

      // 活动上配置了不检查的 直接跳
      if (!this.checkBindCard) {
        location.href = menu.targetUrl
        return
      }

      // 白名单地址 肯定不检查 直接跳
      if (menu.targetUrl.startsWith("/web/order-list")) {
        location.href = menu.targetUrl
        return
      }

      // 活动要求要检查 用户没有卡
      if (null == this.useCardCount || this.useCardCount < 1) {
        Dialog.confirm({ message: "跳转到绑卡?" }).then(() => {
          sessionStorage.setItem("budo.redirect-in-cards-page", location.href) // 绑卡后跳转回本页面
          this.$router.push({ path: 'bind-card' })
        })
        return
      }

      // 用户有卡
      location.href = menu.targetUrl
    },

    checkBindCard_render_menus(res) {
      get_my_allow_use_cards_count().then(countRes => {
        this.useCardCount = countRes?.data

        // 先绑卡 如果未绑卡 就自动跳转到绑卡页
        if ("1" == this.$route.query.get_card_first && this.useCardCount < 1) {
          this.$router.push("/card-mobile-bind")
        } else {
          this.render_menus(res)
        }
      });
    },

    render_menus(res) {
      if (!res?.data?.menus || !res.data.menus.length) {
        $budo_alert("活动未配置菜单")
        return
      }

      const headerMenu = res.data.menus.find(m => m.header === true);
      if (headerMenu) {
        this.headerImg = headerMenu.imgUrl;
      }

      this.menus = res?.data?.menus?.filter(m => m.header === false).sort((a, b) => {
        return (a.sort || 99999) - (b.sort || 99999)
      })

      var pop = res.data.menus.filter(m => m.header == 2 || m.header == 3)
      this.popupMenu = pop?.length ? pop[0] : null
    },

    mounted_loadData() {
      const id = this.$route.query.id || 0;
      this.actId = id;
      budo_log.info('#79 mounted_loadData', id)

      if (id > 0) {
        api_get_act_page_by_id(id).then(res => {
          budo_log.info("#89 api_get_act_page_by_id", res)

          this.title = res?.data?.title;
          this.checkBindCard = res?.data?.checkBindCard;

          if (this.checkBindCard) {
            this.checkBindCard_render_menus(res)
          } else {
            this.render_menus(res)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.act-popup-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  flex-direction: column;

  align-items: center;
}

.act-popup-menu-img {
  margin-top: 10vw;
  max-width: 80vw;
  margin-bottom: 5vw;
  max-height: 85vh;
}

.act-popup-menu-close {
  font-size: 10vw;
  color: white;
}

.textmobile-banner {
  display: none;
  width: 100%;
}

.textmobile-banner img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

.textmobile-content {
  padding: 8px;
}

.editormd-preview-container,
.editormd-html-preview {
  width: auto;
}
</style>
